var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64C14.8264 64 0.5 49.6736 0.5 32C0.5 14.3264 14.8264 0 32.5 0C50.1736 0 64.5 14.3264 64.5 32C64.5 49.6736 50.1736 64 32.5 64ZM32.5 57.6C39.2895 57.6 45.801 54.9029 50.6019 50.1019C55.4029 45.301 58.1 38.7895 58.1 32C58.1 25.2105 55.4029 18.699 50.6019 13.8981C45.801 9.09714 39.2895 6.4 32.5 6.4C25.7105 6.4 19.199 9.09714 14.3981 13.8981C9.59714 18.699 6.9 25.2105 6.9 32C6.9 38.7895 9.59714 45.301 14.3981 50.1019C19.199 54.9029 25.7105 57.6 32.5 57.6ZM32.5 27.4752L41.5496 18.4224L46.0776 22.9504L37.0248 32L46.0776 41.0496L41.5496 45.5776L32.5 36.5248L23.4504 45.5776L18.9224 41.0496L27.9752 32L18.9224 22.9504L23.4504 18.4224L32.5 27.4752Z",
    fill: "#D95A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongCircleIcon);
export default __webpack_public_path__ + "static/media/wrongCircleIcon.367a48c39906dbed04b334026375190b.svg";
export { ForwardRef as ReactComponent };